import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { modalOverlay, modalContent } from '../../config/animations'

export default function ConfirmationModal({ isOpen, onClose, onConfirm, title, message, confirmText = 'Delete', cancelText = 'Cancel' }) {
  if (!isOpen) return null

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-modal overflow-y-auto">
        <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <motion.div
            {...modalOverlay}
            className="fixed inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-xs transition-opacity"
            onClick={onClose}
          />

          <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>

          <motion.div
            {...modalContent}
            className="relative inline-block transform overflow-hidden rounded-xl
                       bg-bg-elevated border border-border
                       px-4 pt-5 pb-4 text-left align-bottom shadow-xl
                       sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle"
          >
            <div>
              <div className="mt-3 text-center sm:mt-5">
                <h3 className="text-lg font-semibold text-text">
                  {title}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-text-secondary">
                    {message}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                className="btn-danger w-full sm:col-start-2"
                onClick={onConfirm}
              >
                {confirmText}
              </button>
              <button
                type="button"
                className="btn-secondary w-full mt-3 sm:col-start-1 sm:mt-0"
                onClick={onClose}
              >
                {cancelText}
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatePresence>
  )
}
